import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import handleGetFullEmpName from '../../../libs/getFullName';
import apiUrl from '../../../libs/baseUrl';
import useSubmitVacation from '../../../customHooks/useSubmitVacation';
import { errorHandeling } from '../../../errorHandeling';

import { TailSpin } from 'react-loader-spinner';
import NavButtonsComp from '../../../components/NavButtonsComp/NavButtonsComp';
import UploadAttachForVacation from '../../../components/VacationRequestComps/UploadAttachForVacation/UploadAttachForVacation';
import ShowUploadedAttach from '../../../components/VacationRequestComps/ShowUploadedAttach/ShowUploadedAttach';
import LottieHandler from "../../../components/LottieHandler/LottieHandler";

import './vacationRequestEmp.scss';


function VacationRequestEmp() {

  const token = useSelector(state => state.user.token);

  const authMe = useSelector(state => state.authme.data);
  
  const { submitTheVacation } = useSubmitVacation();

    // Function to get the current time in "HH:MM" format
    const getCurrentTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0'); // Pad to ensure two digits
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    };


//====State start here====

  const [startingDateVacField , setStartingDateVacField] = useState(new Date().toISOString().split('T')[0] )

  const [endingDateVacField , setEndingDateVacField] = useState(new Date().toISOString().split('T')[0] )

  const [exitPermissionDayField , setExitPermissionDayField] = useState(new Date().toISOString().split('T')[0] )
  

  const [reason,setReason] = useState("");

  const [errorResponsable,setErrorResponsable] = useState("");

  const [loading ,setLoading] = useState(false);

  const [dateError, setDateError] = useState(null);   

  const[vacationType,setVacationType] = useState("DEFAULT");

  const [existPermissionTime , setExistPermissionTime] = useState(getCurrentTime());

  const [missionStartTime , setMissionStartTime] = useState(getCurrentTime());

  const [missionEndTime , setMissionEndTime] = useState(getCurrentTime());

  const [waitingVacationId , setWaitingVacationId] = useState(-1);

  const [waitingVacationStatus , setWaitingVacationStatus] = useState("WAITING_FOR_HR_ACCEPT");

  const [filesArr , setFilesArr] = useState([]);

  const [loadingAuthMe,setLoadingAuthMe] = useState(false)

  const [error,setError] = useState(null);


//====State end here====



//====Event handler start here====

  //check if the authme waitings contain any waiting vacation
  const checkForWaitingVaca = (arr)=>{
    setWaitingVacationId(-1);

    for(let i = 0 ; i < arr.length ; i++){
      let endDate = "" ;
      
      if(arr[i].type === "EXIT_PERMISSION"){
         endDate = arr[i].start_date ;
      }else{
        endDate = arr[i].end_date ;
      }

      let today = new Date();
      let endDateComp = new Date(endDate);
  
      // Strip time info from both dates
      today.setHours(0, 0, 0, 0);
      endDateComp.setHours(0, 0, 0, 0);

        // Compare dates and check that the vaca status is not denyed (if it is denyed and the end time for it bigger than today I dont want to lock the page)
       if(endDateComp >= today && arr[i].status !== "DENIED_FROM_MANAGER" 
        && arr[i].status !== "DENIED_FROM_HR" && arr[i].status !== "DENIED_FROM_DOOR_OFFICER" ){
        setWaitingVacationId(arr[i].id);
        setWaitingVacationStatus(vacationStatusCheck(arr[i].status))
        return ; 
       };

    }

  }


    //check the status of the vacation
    const vacationStatusCheck = (vacaStatus)=>{
      if( vacaStatus === "WAITING_FOR_MANAGER_ACCEPT" )
          return "بانتظار موافقة مدير القسم";
      else if( vacaStatus === "WAITING_FOR_HR_ACCEPT" )
          return "بانتظار موافقة الموارد البشرية";
      else if( vacaStatus === "WAITING_FOR_DOOR_OFFICER_ACCEPT" )
        return "بانتظار موافقة الحرس";
      else if( vacaStatus === "ACCEPTED" )
          return "تم الموافقة عليها";
  
    }


  const fetchAuthmeTemp = async()=>{
    setLoadingAuthMe(true);
      try {
          const response = await axios.post(`${apiUrl}/auth/me`, 
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          );
          checkForWaitingVaca(response.data?.data?.vacations ? response.data.data.vacations : [] )
          setLoadingAuthMe(false);
        } catch (error) {
          setLoadingAuthMe(false);
          setError( errorHandeling(error) );
        }
  }


  let StartingDateVacFieldFunc = (e) => {
    setStartingDateVacField(e.target.value);

  }

  let EndingDateVacFieldFunc = (e) => {
    setEndingDateVacField(e.target.value);

  }


 //for canceling the vacation if there was any vacation in the waiting status
 const handleCancelVacation = async ()=>{

  try {
    setLoading(true)

    const response = await axios.delete(
      `${apiUrl}/vacations/${waitingVacationId}/cancel`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    setLoading(false)

    setErrorResponsable("")
    setDateError(null)
    setReason("")
    fetchAuthmeTemp();
    

  } catch (error) {
    console.error('Error:', error);
    setLoading(false)
    setError(error.message)


  }

}


 const handleSubmit = async (e)=>{
  e.preventDefault();

  await submitTheVacation( exitPermissionDayField , existPermissionTime ,
   startingDateVacField , endingDateVacField , missionStartTime , missionEndTime ,  
   filesArr , reason , authMe.job_id , vacationType , setErrorResponsable , setReason ,
   setLoading , setDateError
    );

}

//====Event handler end here====  


//====useEffect start here====

  useEffect(()=>{
      fetchAuthmeTemp();
  },[])


 useEffect(()=>{

  let validateDate = ()=>{

    // Convert string dates to Date objects for comparison
    const startDate = new Date(startingDateVacField);
    const endDate = new Date(endingDateVacField);
    const exitPermissionDay = new Date(exitPermissionDayField);

    const today = new Date();
    
  // Set the time part of the dates to 00:00:00 for comparison
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  exitPermissionDay.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

    // Check if the starting date is after the ending date
    if (startDate > endDate) {
      setDateError(" *تاريخ البداية يجب ان يكون اصغر من تاريخ نهاية الاجازة");
      setErrorResponsable("date_end")
      return; // Prevent further execution
    }
    // else if(startDate < today){
    //   setDateError("*تاريخ بداية الاجازة يجب أن يحدد ابتداءا من اليوم  وما بعده");
    //   setErrorResponsable("date_start")
    //   return; // Prevent further execution
    // }
    // else if(exitPermissionDay < today){
    //   setDateError("*تاريخ بداية الاجازة يجب أن يحدد ابتداءا من اليوم  وما بعده");
    //   setErrorResponsable("date_exitPermission")
    //   return; // Prevent further execution
    // }
    else {
      setDateError(""); // Clear any previous errors
      // Proceed with form submission logic here
      setErrorResponsable("");
    }
}

  validateDate();

 },[endingDateVacField,startingDateVacField,exitPermissionDayField ])



  useEffect(() => {
    if (vacationType === "DEATH" || vacationType === "MARRIAGE") {
      const startDate = new Date(startingDateVacField);
      startDate.setDate(startDate.getDate() + 7);
      const formattedEndDate = startDate.toISOString().split('T')[0];
      setEndingDateVacField(formattedEndDate);
    }
  }, [vacationType, startingDateVacField]);


//====useEffect end here====



  return (
    <div className='vacationRequsetEmp'>

      { error && 
      <div className='error_show_vacation_Canceling'>
         <span className='error_show_vacation_Canceling_text' dir='rtl'>{error}</span>
      </div>
     
      }

     {
      ( loadingAuthMe )
          ?
      ( <div className='forLoadingVacaEmpReq'>
        <LottieHandler type="kite" message="يتم التحميل ..." />
       </div> )
          :
      ( <>
      {
        waitingVacationId !== -1 ?
        (      <div className='vacationRequsetEmp_vacation_canceling'>
          <div className='vacationRequsetEmp_vacation_canceling_text_cover' >
          <span className='vacationRequsetEmp_vacation_canceling_text' dir='rtl'>تم ارسال طلب الاجازة , {waitingVacationStatus} </span>
          </div>
          {
            (waitingVacationStatus !== "تم الموافقة عليها")  &&
            <button className='vacationRequsetEmp_vacation_canceling_btn' onClick={()=>{handleCancelVacation()}} disabled={loading} dir='rtl'>{ loading ? "يتم المعالجة ..." :  "الغاء طلب الاجازة"}</button>
          }
    
       
        </div>)
        :
        (        <form className="vacationRequestEmp_container" onSubmit={handleSubmit}>
          <span className='vacationRequestEmp_container_title' dir="rtl">طلب اجازة</span>

          <div className="vacationRequestEmp_container_item">
              <span className='vacationRequestEmp_container_item_title' dir="rtl">الرقم الوظيفي</span>
              <span  className='vacationRequestEmp_container_item_info' dir="rtl">{authMe?.job_id}</span>
          </div>
          <div className="vacationRequestEmp_container_item">
              <span className='vacationRequestEmp_container_item_title' dir="rtl">المسؤول المباشر</span>
              <span  className='vacationRequestEmp_container_item_info' dir="rtl">{authMe?.direct_manager ? handleGetFullEmpName(authMe?.direct_manager) : "لم يتم التحديد"}</span>
          </div>

          <div className="vacationRequestEmp_changeResultType_select">
           <label className='vacationRequestEmp_changeResultType_select_label' dir="rtl">نوع الاجازة :</label>
           <select dir="rtl" className='vacationRequestEmp_changaType_selection' value={vacationType} name='vacationType' onChange={(e)=>{setVacationType(e.target.value)}}>
           <option value="DEFAULT" className='vacationRequestEmp_changaType_selection' dir="rtl">اجازة عادية</option>
           <option value="EXIT_PERMISSION" className='vacationRequestEmp_changaType_selection' dir="rtl">اذن الخروج</option>
           <option value="DEATH" className='vacationRequestEmp_changaType_selection' dir="rtl">اجازة وفاة</option>
           <option value="MARRIAGE" className='vacationRequestEmp_changaType_selection' dir="rtl">اجازة زواج</option>
           <option value="MISSION" className='vacationRequestEmp_changaType_selection' dir="rtl">مهمة</option>

           </select>
         </div>

         {//for the note
            (vacationType !== "DEFAULT") &&
            (
              <span className='vacationRequestEmp_changeResultType_Note' dir='rtl'>
              {
                (vacationType === "DEATH" || vacationType === "MARRIAGE") ?
                (<>
                  <span className='vacationRequestEmp_changeResultType_Note_label'>*ملاحظة:</span>
                  عدد أيام الاجازة مدفوعة الاجر الخاص بهذا النوع من الاجازة هو 7 أيام 
                </>
                )
                :
                (vacationType === "EXIT_PERMISSION") ?
                (<>
                  <span className='vacationRequestEmp_changeResultType_Note_label'>*ملاحظة:</span>
                  يجب تحديد اليوم و الوقت الخاص باذن الخروج
                </>
                )
                :
                <></>
  
              }
  
             </span>
            )
         }



        {
          (vacationType !== "EXIT_PERMISSION") ?
         (
            (vacationType !== "MISSION") ?
            (
              <div className='vacationRequestEmp_container_date'>
              <div className="vacationRequestEmp_container_date_item">
                  <span className='vacationRequestEmp_container_date_item_title' dir="rtl">تاريخ البداية</span>
                  <input type="date" dir="rtl"  className={errorResponsable === "date_start" ? 'vacationRequestEmp_container_date_item_info vacationRequestEmp_container_date_item_info_errorDate':'vacationRequestEmp_container_date_item_info'} value={startingDateVacField} onChange={(e)=>StartingDateVacFieldFunc(e)} />
              </div>
               <div className="vacationRequestEmp_container_date_item">
                  <span className='vacationRequestEmp_container_date_item_title' dir="rtl">تاريخ النهاية</span>
                  <input type="date" dir="rtl"  className={errorResponsable === "date_end" ? 'vacationRequestEmp_container_date_item_info vacationRequestEmp_container_date_item_info_errorDate':'vacationRequestEmp_container_date_item_info'} value={endingDateVacField} onChange={(e)=>EndingDateVacFieldFunc(e)} />
              </div>
              </div>
  
            )
            :
            <>
            
            <div className='vacationRequestEmp_container_misson_place'>
              <div className="vacationRequestEmp_container_misson_place_item">
                  <span className='vacationRequestEmp_container_misson_place_item_title' dir="rtl">تاريخ البداية</span>
                  <input type="date" dir="rtl"  className={errorResponsable === "date_start" ? 'vacationRequestEmp_container_misson_place_item_info vacationRequestEmp_container_misson_place_item_info_errorDate':'vacationRequestEmp_container_misson_place_item_info'} value={startingDateVacField} onChange={(e)=>StartingDateVacFieldFunc(e)} />
              </div>
               <div className="vacationRequestEmp_container_misson_place_item">
                  <span className='vacationRequestEmp_container_misson_place_item_title' dir="rtl">تاريخ النهاية</span>
                  <input type="date" dir="rtl"  className={errorResponsable === "date_start" ? 'vacationRequestEmp_container_misson_place_item_info vacationRequestEmp_container_misson_place_item_info_errorDate':'vacationRequestEmp_container_misson_place_item_info'} value={endingDateVacField} onChange={(e)=>EndingDateVacFieldFunc(e)} />
              </div>
              <div className="vacationRequestEmp_container_misson_place_item">
                <span className='vacationRequestEmp_container_misson_place_item_title' dir="rtl">توقيت البداية </span>
                <input type="time" dir="rtl"  className={errorResponsable === "date_start" ? 'vacationRequestEmp_container_misson_place_item_info vacationRequestEmp_container_misson_place_item_info_errorDate':'vacationRequestEmp_container_misson_place_item_info'} value={missionStartTime} onChange={(e)=>setMissionStartTime(e.target.value)} />
            </div>
            <div className="vacationRequestEmp_container_misson_place_item">
                <span className='vacationRequestEmp_container_misson_place_item_title' dir="rtl">توقيت النهاية</span>
                <input type="time" dir="rtl"  className={errorResponsable === "date_start" ? 'vacationRequestEmp_container_misson_place_item_info vacationRequestEmp_container_misson_place_item_info_errorDate':'vacationRequestEmp_container_misson_place_item_info'} value={missionEndTime} onChange={(e)=>setMissionEndTime(e.target.value)} />
            </div>
              </div>

            </>
         )
 
          
          :
          (
            <div className='vacationRequestEmp_exitPermission_date'>
             <div className="vacationRequestEmp_exitPermission_date_item">
                <span className='vacationRequestEmp_exitPermission_date_item_title' dir="rtl">اليوم </span>
                <input type="date" dir="rtl"  className={errorResponsable === "date_exitPermission" ? 'vacationRequestEmp_exitPermission_date_item_info vacationRequestEmp_exitPermission_date_item_info_errorDate':'vacationRequestEmp_exitPermission_date_item_info'} value={exitPermissionDayField} onChange={(e)=>setExitPermissionDayField(e.target.value)} />
            </div>
             <div className="vacationRequestEmp_exitPermission_date_item">
                <span className='vacationRequestEmp_exitPermission_date_item_title' dir="rtl">التوقيت</span>
                <input type="time" dir="rtl"  className={errorResponsable === "date_end" ? 'vacationRequestEmp_exitPermission_date_item_info vacationRequestEmp_exitPermission_date_item_info_errorDate':'vacationRequestEmp_exitPermission_date_item_info'} value={existPermissionTime} onChange={(e)=>setExistPermissionTime(e.target.value)} />
            </div>
            </div>
          )
        }

        {/*To add the attachments*/}
        <UploadAttachForVacation filesArr = { filesArr } setFilesArr = { setFilesArr } setError = { setDateError } />

        {
          ( filesArr.length > 0 ) &&
          ( <ShowUploadedAttach filesArr = { filesArr } setFilesArr = { setFilesArr } /> )
        }
        
          {dateError && <p className='vacationRequestEmp_errorInDateMessage' dir="rtl">{dateError}</p>} 

          <div className="vacationRequestEmp_container_item">
              <span className='vacationRequestEmp_container_item_title' dir="rtl">الاسباب</span>
              <textarea  className={errorResponsable === "reason" ? "vacationRequestEmp_container_item_textarea vacationRequestEmp_container_item_textarea_errorReason" : "vacationRequestEmp_container_item_textarea" } rows="6" cols="50" dir="rtl" onChange={(e)=>{setReason(e.target.value)}}/>
          </div>

      
     { (authMe?.direct_manager) ?
         (<>
          <button type='submit' className='vacationRequestEmp_container_btn' disabled={errorResponsable === "date_start" || errorResponsable === "date_end" } dir="rtl">
          {
         loading ? 
         <>
        <TailSpin
        visible={true}
        height="22"
        width="22"
        color="white"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
        />
       </>
      :
      <>أرسل الطلب</>
      }
         </button>
         </>)
            :
            (<span dir='rtl' style={{padding:"1rem",fontSize:"1rem"}} ><span style={{color:"red",fontSize:"1rem"}}>*</span>لم يتم تحديد مسؤولك المباشر يرجى مراجعة الموارد البشرية</span>)
         }
      


      </form>
      )
      }
      
    {/*for the navivagtion buttons */}
    <NavButtonsComp/>

        </> )} 
    </div>
  )
}

export default VacationRequestEmp;